/**
 * Constantes globales de la aplicación
 */

export const APP_NAME = 'Prixia';
export const APP_VERSION = '1.0.0';

// Configuración de API
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
export const API_TIMEOUT = 30000; // 30 segundos

// Configuración de autenticación
export const TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const USER_KEY = 'user';
export const ACTIVE_ORG_KEY = 'active_organization_id';
export const ORGANIZATIONS_KEY = 'user_organizations';
export const PERMISSIONS_KEY = 'user_permissions';
export const MENU_ITEMS_KEY = 'user_menu_items';
export const LOCKED_MENU_ITEMS_KEY = 'user_locked_menu_items';
/** El nombre con el que `persist` (zustand) guarda todo el store de auth. */
export const AUTH_PERSIST_KEY = 'auth-storage';
/** Respaldo de la sesión del admin mientras está en «Entrar como» (modo soporte). */
export const IMPERSONATION_KEY = 'impersonation_backup';

// Roles de usuario
export const ROLES = {
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  SALESPERSON: 'SALESPERSON',
  APPROVER: 'APPROVER',
} as const;

// Estados de cotización
export const QUOTE_STATUS = {
  DRAFT: 'DRAFT',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  FROZEN: 'FROZEN',
  CANCELLED: 'CANCELLED',
} as const;

// Estados de aprobación
export const APPROVAL_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  ADJUSTMENT_REQUESTED: 'ADJUSTMENT_REQUESTED',
  CANCELLED: 'CANCELLED',
} as const;

// Tipos de variable para modelos de pricing
export const VARIABLE_TYPES = {
  NUMBER: 'NUMBER',
  PERCENTAGE: 'PERCENTAGE',
  CURRENCY: 'CURRENCY',
  TEXT: 'TEXT',
  BOOLEAN: 'BOOLEAN',
  CALCULATED: 'CALCULATED',
} as const;

// Tipos de pago
export const PAYMENT_TYPES = {
  CASH: 'CASH',
  CREDIT: 'CREDIT',
  INSTALLMENTS: 'INSTALLMENTS',
} as const;

// Tipos de impuesto
export const TAX_TYPES = {
  VAT: 'VAT',
  WITHHOLDING: 'WITHHOLDING',
  LOCAL: 'LOCAL',
} as const;

// Niveles de LOB (Line of Business)
export const LOB_LEVELS = {
  SECTOR: 'SECTOR',
  VERTICAL: 'VERTICAL',
  PRODUCT: 'PRODUCT',
} as const;

// Configuración de paginación
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Formatos de fecha
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATETIME_FORMAT = "dd/MM/yyyy 'a las' HH:mm";
export const TIME_FORMAT = 'HH:mm';

// Divisas comunes
export const COMMON_CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'Dólar Estadounidense' },
  { code: 'MXN', symbol: '$', name: 'Peso Mexicano' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'COP', symbol: '$', name: 'Peso Colombiano' },
  { code: 'ARS', symbol: '$', name: 'Peso Argentino' },
  { code: 'CLP', symbol: '$', name: 'Peso Chileno' },
  { code: 'PEN', symbol: 'S/', name: 'Sol Peruano' },
];

// Márgenes por defecto
export const DEFAULT_TARGET_MARGIN = 25; // 25%
export const DEFAULT_FLOOR_MARGIN = 15; // 15%

// Configuración de validación
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

// Mensajes de error comunes
export const ERROR_MESSAGES = {
  REQUIRED: 'Este campo es requerido',
  INVALID_EMAIL: 'Email inválido',
  MIN_LENGTH: (min: number) => `Mínimo ${min} caracteres`,
  MAX_LENGTH: (max: number) => `Máximo ${max} caracteres`,
  PASSWORDS_DONT_MATCH: 'Las contraseñas no coinciden',
  INVALID_NUMBER: 'Debe ser un número válido',
  INVALID_PERCENTAGE: 'Debe ser un porcentaje entre 0 y 100',
  INVALID_CURRENCY: 'Debe ser una cantidad válida',
  NETWORK_ERROR: 'Error de conexión. Verifica tu internet.',
  SERVER_ERROR: 'Error del servidor. Intenta más tarde.',
  UNAUTHORIZED: 'No tienes permiso para realizar esta acción',
  SESSION_EXPIRED: 'Tu sesión ha expirado. Inicia sesión nuevamente.',
};
